import { useLocalization } from '@components/Localization'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, Button, Flex, Text, theme } from '@gassan-ui'
import { CartFragmentFragment } from '@generated'
import { formatPrice } from '@lib/formatPrice'
import React, { FC } from 'react'

const QuickCartFooter: FC<{ cart: CartFragmentFragment }> = ({ cart }) => {
  const { lang, messages } = useLocalization()
  return (
    <Box width="100%" px="2rem">
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        py="1rem"
        borderTop={`1px solid ${theme.colors.shades[200]}`}
        borderBottom={`1px solid ${theme.colors.shades[200]}`}
      >
        <Box>
          <Text mb="0.5rem">{lang === 'nl' ? 'Totaal' : 'Total'}</Text>
          <Text variant="micro" color="shades.500" mb="0">
            {messages.global['free-delivery']}
          </Text>
        </Box>
        <Box textAlign="right">
          <Text mb="0.5rem" variant="regularBold">
            {formatPrice(cart.totalPriceIncTax, true)}
          </Text>
          <Text variant="micro" color="shades.500" mb="0">
            <>
              {lang === 'nl' ? 'Inclusief ' : 'Including '}
              {formatPrice(cart.totalTax, true)}
              {lang === 'nl' ? ' BTW' : ' VAT'}
            </>
          </Text>
        </Box>
      </Flex>
      <Box pt="1rem">
        <LocalizedLink href={messages.navigation.checkout.order}>
          <Button mb="1rem" minWidth="100%" variant="dark" as="link" style={{ width: '100%' }}>
            {lang === 'nl' ? 'Afrekenen' : 'Checkout'}
          </Button>
        </LocalizedLink>
        <LocalizedLink href={messages.navigation.secondaryNav.cart.url}>
          <Button variant="outline" as="link" style={{ width: '100%' }}>
            {lang === 'nl' ? 'Naar winkelwagen' : 'To shopping cart'}
          </Button>
        </LocalizedLink>
      </Box>
    </Box>
  )
}

export default QuickCartFooter
